module.exports = {"SubTexture":[{"x":1,"y":1,"width":2979,"name":"prp_cinta1","height":76},{"x":2982,"y":1,"width":147,"name":"prp_cinta4","height":71}],"width":4096,"name":"cinta","imagePath":"cinta_tex.png","height":128}


//////////////////
// WEBPACK FOOTER
// ./src/resource/cinta/cinta_tex.json
// module id = 344
// module chunks = 0